/**
 * External dependencies
 */
import React from 'react';
import { Box, Heading, Stack, Text } from '@towersystems/towersystems-design-system';
import Tag from 'components/tag';

/**
 * Internal dependencies
 */
import ConnectionTypeTag from 'components/connection-type-tag';

/**
 * Style dependencies
 */
import './styles.scss';

const ConnectionCard = ({ name, type, id, ...r }) => {
    return (
        <Box width='full'>
            <Stack space='medium'>
                <Box display='flex' alignItems='center' justifyContent='center'>
                    <ConnectionTypeTag connectionType={r.connection_type_code} />
                </Box>
                
                <Text size="large" weight='strong'>{name}</Text>
                <Text size="small">{r.enabled == true ? 
                    <Tag className="tag--enabled">Enabled</Tag> : 
                    <Tag className="tag--disabled">Disabled</Tag>}
                </Text>
            </Stack>
        </Box>
    );
};

export default ConnectionCard;
